import AICloudDeveloperPage from "./AICloudDeveloperPage";

export default function AzureDeveloperPage() {
  return <AICloudDeveloperPage technology="azure" />;
}
